import { DefaultFilterHandler, FilterHandlerConfiguration, FilterService } from '@philips-internal/oswald-ui-components';

function setupFilterService(): void {

  const configuration: FilterHandlerConfiguration = {
    loadUrl: '/health-professional-service/resources/filters/:filterId/records',
    removeUrl: '/health-professional-service/resources/filters/:filterId/records/:recordId',
    saveUrl: '/health-professional-service/resources/filters/:filterId/records',
  };

  const filterHandler = new DefaultFilterHandler();
  filterHandler.setConfiguration(configuration);

  FilterService.setFilterHandler(filterHandler);
}

export { setupFilterService };
